import { TextField, Typography } from "@mui/material";
import { IFileUploader } from "../../types";
import UploaderModal from "./UploaderModal";
import { useState } from "react";
import { ImageIcon } from "../../assets/icons/IconRegistery";
import { handleA11yKeyDown } from "../../utils";

const FileUploader = ({
  error,
  files = [],
  getLocalizedText,
  ...rest
}: IFileUploader.Props) => {
  const [showModal, setShowModal] = useState(false);
  const handleCloseModal = () => {
    setShowModal(false);
  };

  const { label } = rest;

  const handleClick = () => setShowModal(true);

  return (
    <Typography component={"div"} sx={{ width: "100%" }}>
      {/* visible component */}

      <TextField
        label={`${getLocalizedText ? getLocalizedText(label) : label} ${
          rest.extraProps?.count ? `(${files.length})` : ""
        }`}
        size="small"
        variant="outlined"
        value={files.map((file) => file.name).join(", ")}
        onClick={handleClick}
        onKeyDown={handleA11yKeyDown(handleClick)}
        fullWidth
        error={!!error}
        helperText={error}
        slotProps={{
          htmlInput: {
            sx: { cursor: "pointer" },
          },
          inputLabel: {
            shrink: !!files.length,
            sx: {
              pl: files.length ? 0 : 3,
              overflow: "hidden",
              textOverflow: "ellipsis",
            },
          },
          input: {
            sx: {
              pr: 0.5,
              pl: 1,
            },
            readOnly: true,
            startAdornment: (
              <ImageIcon
                color={error ? "error" : "inherit"}
                fontSize="medium"
                sx={{ pr: 0, mr: 0.5 }}
              />
            ),
          },
        }}
      />

      {/* file uplodaer modal */}
      {showModal && (
        <UploaderModal
          isOpen={showModal}
          onClose={handleCloseModal}
          files={files}
          getLocalizedText={getLocalizedText}
          {...rest}
        />
      )}
    </Typography>
  );
};

export default FileUploader;
